module.exports = __webpack_public_path__ + "img/72_23.1e2cd4c3.png";